import { render } from "./GallusEngine.vue?vue&type=template&id=4ecbe489&scoped=true&ts=true"
import script from "./GallusEngine.vue?vue&type=script&lang=ts"
export * from "./GallusEngine.vue?vue&type=script&lang=ts"

import "./GallusEngine.vue?vue&type=style&index=0&id=4ecbe489&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecbe489"]])

export default __exports__